﻿import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { ModalDirective } from 'ngx-bootstrap';
import { NotificationsService } from 'angular2-notifications';



@Component({
  selector: 'app-inpr-qual-issu',
  templateUrl: './inpr-qual-issu.component.html',
  styleUrls: ['./inpr-qual-issu.component.css']
})
export class InprQualIssuComponent implements OnInit {
  mId:string = "773881e1-3f3a-49be-865a-1a2f0312be8d";
  hasmodaccess:boolean = false;
  selView:number = 0;
  @ViewChild('childModal') public childModal:ModalDirective; 
  editHeader: string ="";
  generateExcelFromDate:any;
  generateExcelToDate:any;




  constructor(private _dataService:DataService, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Inprocess Quality Issues";

  
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }
  exportToExcel(){
    var startDate = new Date(this.generateExcelFromDate);
    var endDate  = new Date(this.generateExcelToDate);
    if(this.validateStartEndDate(startDate,endDate)){
        this._dataService.downloadFile(startDate,endDate,"Inprocess", '');
        this.hideChildModal();
    }
  }
  
  validateStartEndDate(_startDate:Date,_endDate:Date):boolean{
    if(_startDate > _endDate){
      this._notify.error('Failure','Invalid Date',this._dataService.failureOptions);
      return false;
    }

    return true;
  }
  showExportModel(){
    this.editHeader = "Export To Excel";
    this.generateExcelFromDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.generateExcelToDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.childModal.show();
  }

  hideChildModal(){
    this.childModal.hide();
 }
}
